import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "ant-upload-text" }, "Upload", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PlusOutlined = _resolveComponent("PlusOutlined")!
  const _component_a_upload = _resolveComponent("a-upload")!

  return (_openBlock(), _createBlock(_component_a_upload, {
    accept: "image/*",
    "list-type": "picture-card",
    fileList: _ctx.fileList,
    "onUpdate:fileList": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fileList) = $event)),
    beforeUpload: _ctx.beforeUpload,
    "max-count": _ctx.max,
    onPreview: _ctx.preview,
    onChange: _ctx.onFileChange
  }, {
    default: _withCtx(() => [
      (_ctx.fileList.length < 8)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_PlusOutlined),
            _hoisted_2
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileList, (file, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          _renderSlot(_ctx.$slots, "imageRender", { file: file })
        ]))
      }), 128))
    ]),
    _: 3
  }, 8, ["fileList", "beforeUpload", "max-count", "onPreview", "onChange"]))
}